import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { EndpointsService, NotificationService } from "../core/services";

@Injectable()
export class BrandPreidService {
    private static notificationService;
    constructor(private http: Http, private endpointsService: EndpointsService, private notificationService: NotificationService) {
        BrandPreidService.notificationService = notificationService;
    }

    public getUnidentifiedAds(pageNumber: number, pageSize: number, mediaFile:string): Observable<Response> {
        return this.http.get(`${this.endpointsService.GET_UNIDENTIFIED_ADS}?pageNumber=${pageNumber}&pageSize=${pageSize}&mediaFile=${mediaFile}`)
            .catch(this.handleError);
    }

    public setIdentifiedAd(mediaFile: string, brandId: number, logoUrl: string, logoHeight: number, logoWidth: number, title: string, description: string): Observable<Response> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.endpointsService.SET_IDENTIFIED_AD, { brandId, mediaFile, logoUrl, logoHeight, logoWidth, title, description }, options)
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        if (error.status === 400)
            BrandPreidService.notificationService.showError(error.json().message)
        else
            BrandPreidService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/brand-preid/brand-preid.service.ts